export const colors = {
  primary: "var(--color-primary)",
  secondary: "var(--color-secondary)",
  text: "var(--color-text)",
  textSoft: "var(--color-text-soft)",
  error: "var(--color-text-error)",
};
